import { ColDef } from 'ag-grid-community';
import moment from 'moment';
import FundingAmount from 'ts/models/FundingAmount.model';

export type FundingRateRow = FundingAmount & {
  exchangeMicCode?: string;
};

const columnDefs: ColDef<FundingRateRow>[] = [
  {
    field: 'tradeDate',
    headerName: 'Trade Date',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'productSymbol',
    headerName: 'Product Symbol',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'contractSymbol',
    headerName: 'Exchange Symbol',
    filter: 'agTextColumnFilter',
  },
  { field: 'fundingRate', headerName: 'Funding Rate' },
  { field: 'unitFundingAmount', headerName: 'Unit Funding Amount' },
  {
    field: 'creationType',
    headerName: 'Settlement Type',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'timestamp',
    filter: 'agTextColumnFilter',
    headerName: 'Timestamp',
    valueFormatter: ({ value }: { value: string }) =>
      value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-',
  },
];

export default columnDefs;
